import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-validations-dialog',
  templateUrl: './validations-dialog.component.html',
  styleUrls: ['./validations-dialog.component.css'],
})
export class ValidationsDialogComponent {
  Errors: any;
  typeOfMessage: string;
  customMsg: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { message: any }
  ) {
    this.typeOfMessage = typeof data?.message;
    // if (this.data?.message?.detail) {
    //   let field = this.data?.message?.detail?.split(':')[0];
    //   if (field) {
    //     const newMsg = this.data?.message?.detail?.replace(field + ':', ' ');
    //     this.data.message.detail = newMsg;
    //   }
    // }
    // if (data?.message?.additionalDetails) {
    //   this.replaceDataInError(data?.message?.additionalDetails);
    // }
    this.Errors = data?.message;
    if (
      this.Errors ==
      '{"Message":"Service is not working","Error":"Error: GLS API Response Status Code: 401 Status Message: Unauthorized"}'
    ) {
      this.customMsg = true;
    }
  }

  replaceDataInError(msgDetails) {
    for (let index = 0; index < msgDetails?.length; index++) {
      const field = this.data?.message?.additionalDetails[index]?.split(':')[0];
      if (field) {
        const newMsg = this.data?.message?.additionalDetails[index]?.replace(field + ':', ' ');
        this.data.message.additionalDetails[index] = newMsg;
      }
    }
  }
}
